import React, { useEffect } from "react";

import { browserHistory } from "js/react/history";

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void;
    }
}

export const DEFAULT_HARD_CAP_MS = 800;

/**
 * Run navigation after GA4 flushes a queued hit, or after a hard timeout.
 */
export function navigateAfterAnalytics(doNavigate: () => void) {
    let navigated = false;
    let timeoutId: number | undefined;

    const callback = () => {
        if (navigated) {
            return;
        }
        navigated = true;
        if (timeoutId !== undefined) {
            window.clearTimeout(timeoutId);
        }
        doNavigate();
    };

    timeoutId = window.setTimeout(callback, DEFAULT_HARD_CAP_MS);
    window.gtag?.("event", "nav_ready", {
        event_callback: callback,
        event_timeout: DEFAULT_HARD_CAP_MS
    });
}

interface AnalyticsGatedRedirectProps {
    to: string;
}

export function AnalyticsGatedRedirect(props: AnalyticsGatedRedirectProps) {
    const { to } = props;

    useEffect(() => {
        navigateAfterAnalytics(() => browserHistory.replace(to));
    }, [to]);

    return null;
}
